import request from '@/utils/request';
import config from '@/config';

const { apiInfo } = config;
const userUrl = `${apiInfo.user.prefix}${apiInfo.user.group}`;

export function getAllUsers(params) {
    const url =
        userUrl +
        `?country=${params.country}&email=${params.email}&actived=${
            params.actived
        }&roles=${params.roles}&pageIndex=${params.pageIndex}&pageSize=${
            params.pageSize
        }`;

    return request({
        url: url,
        method: 'get',
        headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
    });
}

export function createUser(userInfo) {
    const url = userUrl;

    return request({
        url: url,
        method: 'post',
        headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
        data: {
            userID: userInfo.id,
            userName: userInfo.userName,
            userAccount: userInfo.email,
            fullName: userInfo.fullName,
            country: userInfo.country,
            userPassword: '',
            lastLogonTime: userInfo.date,
            isSystemUser: userInfo.isSystemUser,
            activeFlg: userInfo.activeFlg,
            createTime: userInfo.date,
            role: userInfo.role
        }
    });
}

export function editUser(userInfo) {
    const url = userUrl;

    return request({
        url: url,
        method: 'put',
        headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
        data: {
            userID: userInfo.id,
            userName: userInfo.userName,
            userAccount: userInfo.email,
            fullName: userInfo.fullName,
            country: userInfo.country,
            userPassword: '',
            lastLogonTime: userInfo.date,
            isSystemUser: userInfo.isSystemUser,
            activeFlg: userInfo.activeFlg,
            createTime: userInfo.date,
            role: userInfo.role
        }
    });
}

export function getUser(id) {
    const url = userUrl + `/${id}`;

    return request({
        url: url,
        method: 'get',
        headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
    });
}
export function getUserByRoleID(id) {
    const url = userUrl + 'ByRoleId' + `?roleid=${id}`;

    return request({
        url: url,
        method: 'get',
        headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
    });
}
export function getUserByRoleIdCountry(roleid, businessCountry) {
    const url =
        'api/UserByRoleIdCountry' +
        `?roleid=${roleid}&businessCountry=${businessCountry}`;

    return request({
        url: url,
        method: 'get',
        headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
    });
}

export function deleteUser(id) {
    const url = userUrl + `?userID=${id}`;

    return request({
        url: url,
        method: 'delete'
    });
}



// WEBPACK FOOTER //
// ./src/api/user.js